import { render, staticRenderFns } from "./CourseLeaderboard.vue?vue&type=template&id=5265e103&scoped=true&"
import script from "./CourseLeaderboard.vue?vue&type=script&lang=js&"
export * from "./CourseLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./CourseLeaderboard.vue?vue&type=style&index=0&id=5265e103&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265e103",
  null
  
)

export default component.exports